import { FieldMetaProps } from 'formik'

export const getHasError = (meta: FieldMetaProps<string | number>, submitCount: number) =>
  Boolean(meta.error) && (meta.touched || submitCount > 0)
